import React, { useState, useEffect } from "react";
import CircuitLayout from "./CircuitLayout";

interface CircuitTransitionProps {
  circuits_id: string;
  circuits_name: string;
  id_canvas: string;
  isRaceEntries?: boolean;
  color?: string;
  strokeWidth?: number;
  isCalendar?: boolean;
}

const CircuitTransition: React.FC<CircuitTransitionProps> = ({
  circuits_id,
  circuits_name,
  id_canvas,
  isRaceEntries,
  color,
  strokeWidth,
  isCalendar,
}) => {
  const circuitIds = circuits_id.split(",");
  const circuitNames = circuits_name.split(",");
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (circuitIds.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % circuitIds.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [circuitIds.length]);

  if (circuitIds.length === 0) return null;

  return (
    <div
      id={
        isRaceEntries
          ? "parent-rallytracks"
          : isCalendar
            ? "parent-rallytrackscalendar"
            : ""
      }
    >
      <p className="rally-circuitname">{circuitNames[currentIndex]}</p>
      <CircuitLayout
        circuit_id={parseInt(circuitIds[currentIndex])}
        id_canvas={id_canvas}
        color={color}
        strokeWidth={strokeWidth}
      />
    </div>
  );
};

export default CircuitTransition;
